module.exports = __webpack_public_path__ + "img/gongsi_act.331f7b21.png";